await themeComponent(theme.components['mc-element'], false);
class McCollection extends McElement {
  constructor(){
    super();
    this.view = 0;
    this.url = new URL(window.location.href);
    this.views = [];
    this._btnRefs = [];
  }

  connectedCallback(){
    // parse views from data attribute
    if (this.dataset.views){
      this.views = this.dataset.views
        .split(',')
        .map(s => s.trim())
        .filter(Boolean)
        .map(s => {
          const [desktop='', mobile=''] = s.split(':').map(x => x.trim());
          return { desktop, mobile };
        });
    }

    // find ALL mc-btns that toggle views (desktop + mobile)
    const listingId = '#collection-card-listing';
    this._btnRefs = Array.from(document.querySelectorAll(`mc-btn[data-target="${listingId}"]`));
    this._btnRefs.forEach(btn => {
      btn.addEventListener('click', () => this.changeView());
    });

    // init from URL or default
    const v = parseInt(this.url.searchParams.get('view'), 10);
    this.setView(Number.isFinite(v) ? v : 0);
  }

  changeView = () => {
    if (!this.views.length) return;
    this.setView((this.view + 1) % this.views.length);
  }

  setView = (viewNumber) => {
    // remove old view classes
    if (this.views[this.view]) {
      this.classList.remove(this.views[this.view].desktop, this.views[this.view].mobile);
    }

    // clamp & apply new view
    this.view = Math.max(0, Math.min(viewNumber, this.views.length - 1));
    if (this.views[this.view]) {
      this.classList.add(this.views[this.view].desktop, this.views[this.view].mobile);
    }

    // persist state in URL
    //this.url.searchParams.set('view', this.view);
    //window.history.replaceState(null, null, this.url);

    // sync icons on all relevant buttons
    this._updateAllButtonIcons();
  }

  _updateAllButtonIcons = () => {
    const isGrid = this.view === 0; // adjust if >2 views
    this._btnRefs.forEach(btn => {
      const colIcon  = btn.querySelector('.icon-col');
      const gridIcon = btn.querySelector('.icon-grid');
      if (colIcon)  colIcon.classList.toggle('hidden',  !isGrid);
      if (gridIcon) gridIcon.classList.toggle('hidden', isGrid);
    });
  }
}

if(!window.customElements.get('mc-collection')){
  window.customElements.define('mc-collection', McCollection);
}
window.McCollection = McCollection;
